import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaDollarSign,
  FaStar,
  FaShieldAlt,
} from "react-icons/fa";

const AboutSection = () => {
  return (
    <section className="about-section fix section-padding section-bg">
      <div className="container">
        {/* Tiêu đề */}
        <div className="section-title-area">
          <div className="section-title">
            <h6 className="wow fadeInUp">Về Chúng Tôi</h6>
            <h2
              className="wow fadeInUp"
              data-wow-delay=".3s"
            >
              Sáng Tạo <span>Giải Pháp Thương Hiệu</span> <br /> Cho Các Doanh
              Nghiệp Hiện Đại
            </h2>
          </div>
          <p
            className="wow fadeInUp"
            data-wow-delay=".5s"
          >
            Nơi giao thoa giữa tầm nhìn và thực thi, đội ngũ Design24 biến ý
            tưởng sáng tạo thành những câu chuyện thương hiệu hấp dẫn và hiệu
            quả.
          </p>
        </div>

        <div className="about-wrapper">
          <div className="row justify-content-between align-items-center">
            {/* Ảnh minh họa */}
            <div className="col-lg-7">
              <div className="about-image-items">
                <div className="row g-4 align-items-center">
                  <div
                    className="col-md-6 wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="support-content">
                      <h3>Hỗ Trợ 24/7</h3>
                      <div className="text-area">
                        <p>Design24 luôn sẵn sàng hỗ trợ bạn</p>
                        <Link
                          to="/gioi-thieu"
                          className="icon"
                        >
                          <FaArrowRight />
                        </Link>
                      </div>
                    </div>
                    <div className="about-image">
                      <img
                        src="/assets/img/about/home-about-01.webp"
                        alt="Hỗ trợ 24/7"
                      />
                    </div>
                  </div>

                  <div
                    className="col-md-6 wow fadeInUp"
                    data-wow-delay=".5s"
                  >
                    <div className="about-image-2">
                      <div className="about-image style-2">
                        <img
                          src="/assets/img/about/home-about-02.webp"
                          alt="Sáng tạo thương hiệu"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Nội dung */}
            <div className="col-lg-5">
              <div className="about-content">
                {/* Mission */}
                <div
                  className="about-icon-items wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="icon">
                    <FaDollarSign />
                    <div className="line-bar">
                      <img
                        src="/assets/img/about/line.png"
                        alt="line"
                      />
                    </div>
                  </div>
                  <div className="content">
                    <h3>Sứ Mệnh</h3>
                    <p>
                      Chúng tôi giúp các thương hiệu phát triển bằng những giải
                      pháp sáng tạo, độc đáo và mang lại hiệu quả thực tiễn.
                    </p>
                  </div>
                </div>

                {/* Vision */}
                <div
                  className="about-icon-items wow fadeInUp"
                  data-wow-delay=".5s"
                >
                  <div className="icon">
                    <FaStar />
                    <div className="line-bar">
                      <img
                        src="/assets/img/about/line.png"
                        alt="line"
                      />
                    </div>
                  </div>
                  <div className="content">
                    <h3>Tầm Nhìn</h3>
                    <p>
                      Trở thành đối tác tin cậy, truyền cảm hứng và đưa các
                      thương hiệu Việt vươn tầm quốc tế.
                    </p>
                  </div>
                </div>

                {/* What sets apart */}
                <div
                  className="about-icon-items wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <div className="icon">
                    <FaShieldAlt />
                    <div className="line-bar">
                      <img
                        src="/assets/img/about/line.png"
                        alt="line"
                      />
                    </div>
                  </div>
                  <div className="content">
                    <h3>Điểm Khác Biệt</h3>
                    <p>
                      Chúng tôi kết hợp sáng tạo và chiến lược, mang đến các
                      giải pháp toàn diện và hiệu quả cho khách hàng.
                    </p>
                  </div>
                </div>

                <Link
                  to="/gioi-thieu"
                  className="theme-btn wow fadeInUp"
                  data-wow-delay=".5s"
                >
                  Tìm Hiểu Thêm
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
